/**
 * Point the page favicon at `href` by replacing the `<link rel="icon">` element
 * rather than mutating its `href`. Browsers (Chrome in particular) commit to the
 * favicon loaded at first paint — the `data:` placeholder in index.html — and
 * ignore a later `href` mutation on that same element, so the tenant/brand
 * favicon never appeared in the tab. Removing the element and appending a fresh
 * one forces the browser to re-fetch.
 *
 * Idempotent: a no-op when the current icon link already targets `href`.
 */
export function applyFavicon(doc: Document, href: string): void {
  const existing = doc.head.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (existing?.getAttribute('href') === href) {
    return;
  }
  doc.head.querySelectorAll('link[rel="icon"]').forEach((link) => link.remove());
  const link = doc.createElement('link');
  link.setAttribute('rel', 'icon');
  link.id = 'appIcon';
  link.setAttribute('href', href);
  doc.head.appendChild(link);
}
